<div class="col gap-4">
    <div class="w100 row space-between">
        <div class="col leftsidearea">
            <div class="row space-between gap-8 w100">
                <h1 class="strong">{{ stream?.name }}</h1>
                <rr-icon
                    name="edit"
                    class="pointer"
                    (click)="editMetaData()"
                ></rr-icon>
            </div>
            <div>Stream Description: {{ stream?.description }}</div>
        </div>

        <div class="col gap-4 tiny align-end steparea">
            <span *ngIf="stream?.dateCreate"
                >Created On:
                {{ stream?.dateCreate! | getLocaldateByTime }}</span
            >
            <span
                *ngIf="
                    stream?.creatingUserPrename || stream?.creatingUserLastname
                "
                >Created By: {{ stream?.creatingUserPrename }}
                {{ stream?.creatingUserLastname }}</span
            >
            <span *ngIf="stream?.dateUpdate"
                >Updated On:
                {{ stream?.dateUpdate! | getLocaldateByTime }}</span
            >
            <span
                *ngIf="
                    stream?.updatingUserPrename || stream?.updatingUserLastname
                "
                >Updated By: {{ stream?.updatingUserPrename }}
                {{ stream?.updatingUserLastname }}
            </span>
            <rr-btn size="Small" type="Secondary">{{ stream?.llmId }}</rr-btn>
        </div>
    </div>
    <div class="w100 row gap-40">
        <div class="row gap-8">
            <rr-badge tone="success">{{ stream?.status }}</rr-badge>
            <rr-badge tone="info">{{ stream?.type }}</rr-badge>
            @if (stream?.globalStream !== true) {
                <rr-badge tone="error">Private</rr-badge>
            } @else {
                <rr-badge tone="warning">Global </rr-badge>
            }
        </div>
        <div class="row gap-4">
            <rr-badge *ngFor="let cat of stream?.categoryId">{{
                cat | getCategoryNameById
            }}</rr-badge>
        </div>
    </div>
</div>

<div class="row gap-24 h100 grow-1">
    <div class="contentarea card col w100">
        <!-- ========== CONFIG EDIT ==========  -->
        <div class="stepedit w100" *ngIf="activeStep">
            <div class="w100 row space-between">
                <span
                    >Step {{ activeStepNumber }} /
                    {{ stream?.steps?.length || 0 }}</span
                >
                <rr-icon
                    name="edit"
                    class="w16 pointer"
                    (click)="editActive = !editActive; cd.detectChanges()"
                ></rr-icon>
            </div>
            <div class="col w100 gap-64">
                @if (editActive === true) {
                    <h1 class="w100">Edit your Step</h1>
                    <div class="bgsunken col w100 gap-8">
                        <h2>Main Data</h2>
                        <rr-input
                            [(ngModel)]="activeStep.name"
                            label="Name"
                        ></rr-input>
                        <rr-textarea
                            label="Description"
                            [(ngModel)]="activeStep.description"
                        ></rr-textarea>
                        <rr-textarea
                            label="Step Goal"
                            [(ngModel)]="activeStep.stepGoal"
                        ></rr-textarea>
                        <div class="row gap-8 w100">
                            <rr-input
                                label="Credits"
                                [(ngModel)]="activeStep.credits"
                                type="number"
                                hint="Will be automatically generated, or set manually."
                            ></rr-input>

                            <rr-input
                                label="Duration"
                                [(ngModel)]="activeStep.duration"
                                type="number"
                                hint="Will be automatically generated, or set manually."
                            ></rr-input>
                        </div>
                    </div>
                    <div class="bgsunken col w100 gap-8">
                        <h2>Key Questions</h2>
                        <div class="keyquestionwrapper col gap-8">
                            <div
                                class="row gap-16 space-between w100 align-center"
                                *ngFor="
                                    let q of activeStep.keyQuestions;
                                    let i = index
                                "
                            >
                                <div class="col">
                                    <rr-icon
                                        name="chevron-up"
                                        class="w20 pointer"
                                        (click)="changeQuestionOrder(i, i - 1)"
                                        *ngIf="i !== 0"
                                    ></rr-icon>
                                    <rr-icon
                                        name="chevron-down"
                                        class="w20 pointer"
                                        (click)="changeQuestionOrder(i, i + 1)"
                                        *ngIf="
                                            i + 1 !==
                                            activeStep.keyQuestions.length
                                        "
                                    ></rr-icon>
                                </div>
                                <div
                                    *ngIf="i !== editKeyQuestion"
                                    class="row gap-16 space-between w100 align-center"
                                >
                                    <div
                                        class="card w100 col grow-1"
                                        *ngIf="i !== editKeyQuestion"
                                    >
                                        <span class="strong">{{
                                            q.title
                                        }}</span>
                                        <span class="">{{ q.question }}</span>
                                        <span class="tiny">{{
                                            q.description
                                        }}</span>
                                    </div>
                                    <rr-icon
                                        *ngIf="i !== editKeyQuestion"
                                        class="roundicon w24 pointer"
                                        name="edit"
                                        (click)="toggleKeyQuestionEdit(i, q)"
                                    ></rr-icon>
                                    <rr-icon
                                        *ngIf="i !== editKeyQuestion"
                                        class="roundicon w24 pointer"
                                        name="trash"
                                        (click)="removeKeyQuestion(i)"
                                    ></rr-icon>
                                </div>
                                <div
                                    *ngIf="i === editKeyQuestion"
                                    class="row gap-16 space-between w100 align-center"
                                >
                                    <div class="card w100 col grow-1">
                                        <rr-input
                                            placeholder="Title for Key-Question"
                                            [FormControl]="editKeyQuestionTitle"
                                        ></rr-input>
                                        <rr-input
                                            placeholder="The question"
                                            [FormControl]="editKeyQuestionQ"
                                        ></rr-input>
                                        <rr-textarea
                                            placeholder="Provide additional details"
                                            (change)="
                                                onKeyQuestionDetailsChange(
                                                    $event
                                                )
                                            "
                                            [value]="q.description"
                                        ></rr-textarea>
                                    </div>
                                    <rr-icon
                                        class="roundicon w24 pointer"
                                        name="save"
                                        (click)="saveKeyQuestionEdit(i)"
                                    ></rr-icon>
                                    <rr-icon
                                        class="roundicon w24 pointer"
                                        name="close"
                                        (click)="toggleKeyQuestionEdit(i, q)"
                                    ></rr-icon>
                                </div>
                            </div>
                        </div>
                        <div class="col questionadder w100">
                            <div class="strong">Add a Key Question:</div>
                            <div class="col gap-8 w100">
                                <rr-input
                                    placeholder="Title for Key-Question"
                                    #newQuestionTitle
                                ></rr-input>
                                <rr-input
                                    placeholder="The question"
                                    #newQuestion
                                ></rr-input>
                                <rr-textarea
                                    placeholder="Provide additional details"
                                    #newDetails
                                ></rr-textarea>
                                <div
                                    class="row w100 align-center justify-end gap-24"
                                >
                                    <rr-btn
                                        size="Small"
                                        type="Link"
                                        (click)="
                                            newQuestionTitle.FormControl.setValue(
                                                ''
                                            );
                                            newQuestion.FormControl.setValue(
                                                ''
                                            );
                                            newDetails.FormControl.setValue('')
                                        "
                                        >Reset Question-Form</rr-btn
                                    >
                                    <rr-btn
                                        size="Small"
                                        type="Secondary"
                                        iconStart="add"
                                        [disabled]="
                                            newQuestion.FormControl.value !==
                                                null &&
                                            newQuestion.FormControl.value != ''
                                                ? false
                                                : true
                                        "
                                        (click)="
                                            newQuestion.FormControl.value !==
                                                null &&
                                            newQuestion.FormControl.value !== ''
                                                ? addKeyQuestion(
                                                      newQuestionTitle
                                                          .FormControl.value,
                                                      newQuestion.FormControl
                                                          .value,
                                                      newDetails.value
                                                  )
                                                : null
                                        "
                                        >Add Key Question</rr-btn
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col w100 gap-8 bgsunken">
                        <div class="row gap-8 w100 align-center">
                            <rr-checkbox
                                [(ngModel)]="activeStep.websearchStatus"
                                [checked]="activeStep.websearchStatus"
                                (click)="checkboxChange()"
                            ></rr-checkbox>
                            <h2>Websearch</h2>
                        </div>
                        @if (activeStep.websearchStatus === true) {
                            <div class="col gap-8 w100">
                                <div class="keyquestionwrapper col gap-8">
                                    @if (
                                        activeStep.websearch &&
                                        activeStep.websearch.length > 0
                                    ) {
                                        <div
                                            class="row gap-16 space-between w100 align-center"
                                            *ngFor="
                                                let q of activeStep.websearch;
                                                let i = index
                                            "
                                        >
                                            <div class="card w100 col grow-1">
                                                <span class="strong"
                                                    >{{ q.title }} |
                                                    {{ q.source }}
                                                </span>
                                                <span>{{ q.query }}</span>
                                                <span class="tiny">{{
                                                    q.description
                                                }}</span>
                                            </div>
                                            <rr-icon
                                                class="roundicon w24 pointer"
                                                name="trash"
                                                (click)="removeWebQuestion(i)"
                                            ></rr-icon>
                                        </div>
                                    }
                                </div>
                                <div class="col gap-8 w100">
                                    <rr-input
                                        label="Websearch title"
                                        [(ngModel)]="websearchObject.title"
                                    ></rr-input>
                                    <rr-input
                                        label="Websearch query"
                                        [(ngModel)]="websearchObject.query"
                                    ></rr-input>
                                    <rr-select
                                        label="Source"
                                        [options]="webSearchSources"
                                        optionName="name"
                                        optionValue="id"
                                        [(ngModel)]="websearchObject.source"
                                    ></rr-select>
                                    <rr-textarea
                                        label="Description"
                                        [(ngModel)]="
                                            websearchObject.description
                                        "
                                    ></rr-textarea>
                                    <div
                                        class="row w100 align-center justify-end gap-24"
                                    >
                                        <rr-btn
                                            size="Small"
                                            type="Secondary"
                                            iconStart="add"
                                            [disabled]="
                                                websearchObject.query === '' &&
                                                websearchObject.source === ''
                                                    ? true
                                                    : false
                                            "
                                            (click)="
                                                websearchObject.query === '' &&
                                                websearchObject.source === ''
                                                    ? null
                                                    : addWebQuestion()
                                            "
                                            >Add Web Question</rr-btn
                                        >
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div class="bgsunken col w100 gap-8">
                        <div class="row gap-8 align-center">
                            <rr-checkbox
                                [(ngModel)]="activeStep.uploadStatus"
                                [checked]="activeStep.uploadStatus"
                                (click)="checkboxChange()"
                            >
                            </rr-checkbox>
                            <h2>File upload</h2>
                        </div>
                        @if (activeStep.uploadStatus === true) {
                            <div class="col gap-8 bgsunken w100">
                                <rr-textarea
                                    label="Prompt to handel result"
                                    [(ngModel)]="
                                        activeStep.upload!.resultPrompt
                                    "
                                ></rr-textarea>
                            </div>
                        }
                    </div>
                    <div class="bgsunken col w100 gap-8">
                        <h2>Closing Data</h2>

                        <rr-select
                            label="Closing Asset"
                            [(ngModel)]="activeStep.closingPromptId"
                            [options]="closingStreamTypes"
                            [preselectedValue]="
                                activeStep.closingPromptId || 'CLS_PDF_DEFAULT'
                            "
                            optionName="name"
                            optionValue="id"
                        ></rr-select>
                        <!-- <h4 *ngIf="(stream?.steps)!.length > 1">Required Steps</h4>
                    <div class="reqstewrapper col gap-8">
                        @for(s of stream?.steps; track s.id) {
                        <rr-checkbox *ngIf="activeStep.id !== s.id">{{
                            s.name
                        }}</rr-checkbox>
                        }
                    </div> -->
                    </div>
                    <div class="bgsunken col w100 gap-8">
                        <h2>Agent Data</h2>
                        <rr-select
                            label="Agent for the Configuration"
                            [required]="true"
                            [options]="agentList"
                            optionName="name"
                            optionValue="id"
                            [preselectedValue]="activeStep.agentId"
                            [(ngModel)]="activeStep.agentId"
                        ></rr-select>
                        <rr-textarea
                            label="Extended Agent Prompt"
                            [(ngModel)]="activeStep.agentPrompt"
                            placeholder="Provide an extended agent prompt, to make a difference between other configurations."
                        ></rr-textarea>
                    </div>
                } @else {
                    <div class="col">
                        <h1>{{ activeStep.name }}</h1>
                        <div>{{ activeStep.description }}</div>
                        <div class="row gap-8 w100">
                            <rr-badge tone="success"
                                >Credits: {{ activeStep.credits }}</rr-badge
                            >
                            <rr-badge tone="information"
                                >Duration: {{ activeStep.duration }}</rr-badge
                            >
                            <rr-badge tone="warning"
                                >Websearch:
                                {{
                                    activeStep.websearchStatus === false
                                        ? "NO"
                                        : "YES"
                                }}</rr-badge
                            >
                            <rr-badge tone="warning"
                                >File upload:
                                {{
                                    activeStep.uploadStatus === false
                                        ? "NO"
                                        : "YES"
                                }}</rr-badge
                            >
                        </div>
                    </div>
                    <div class="col w100 gap-8">
                        <h3>Key Questions</h3>
                        <div
                            class="col w100 keyquestionlist"
                            *ngFor="let q of activeStep.keyQuestions"
                        >
                            <span class="strong">{{ q.title }}</span>
                            <span class="">{{ q.question }}</span>
                            <span class="tiny">{{ q.description }}</span>
                        </div>
                    </div>
                    <!-- <div
                    class="col w100 gap-8"
                    *ngIf="activeStep.requiredStepIds.length !== 0"
                >
                    <h3>Required Steps</h3>
                </div> -->
                }
            </div>
        </div>
        <!-- ========== CONFIG EDIT ==========  -->
    </div>
    <div class="steparea col gap-8">
        <!-- For every Step -->
        <div
            class="row gap-16 singlestep exist"
            [ngClass]="activeStepNumber === i + 1 ? 'active' : ''"
            *ngFor="let step of stream?.steps; let i = index"
        >
            <div
                class="col justify-start gap-8 align-center align-self-stretch"
            >
                <div class="dot"></div>
                <div class="line grow-1"></div>
            </div>
            <div class="col stepoverviewcontent">
                <div class="row space-between w100 align-center">
                    <div class="row gap-8 align-center">
                        <div class="col">
                            <rr-icon
                                name="chevron-up"
                                class="w20 pointer"
                                (click)="switchStepOrder(i, i - 1)"
                                *ngIf="i !== 0"
                            ></rr-icon>
                            <rr-icon
                                name="chevron-down"
                                class="w20 pointer"
                                (click)="switchStepOrder(i, i + 1)"
                                *ngIf="i + 1 !== stream?.steps?.length"
                            ></rr-icon>
                        </div>
                        <h4
                            class="stepheadline"
                            (click)="setStepForEdit(step, i)"
                        >
                            {{ i + 1 }}. | {{ step.name }}
                        </h4>
                    </div>
                    <rr-icon
                        name="trash"
                        class="w16 pointer"
                        (click)="deleteStep(i)"
                    ></rr-icon>
                </div>
                <div class="stepcontent" (click)="setStepForEdit(step, i)">
                    {{ step.description }}
                </div>
            </div>
        </div>
        <!-- Default Add Step -->
        <div class="row gap-16 singlestep">
            <div
                class="col justify-start gap-4 align-center align-self-stretch"
            >
                <div class="dot"></div>
                <div class="line grow-1"></div>
            </div>
            <div class="col stepoverviewcontent">
                <div class="row space-between w100">
                    <h4 class="stepheadline">Add a Step</h4>
                </div>
                <div class="tiny">Define what happens in the stream.</div>
                <div class="stepcontent row gap-8 align-center">
                    <rr-btn
                        type="Secondary"
                        size="Small"
                        iconStart="list"
                        (click)="selectConfig()"
                        >Select Config</rr-btn
                    >
                    <rr-btn
                        type="Link"
                        size="Small"
                        iconStart="add"
                        (click)="addConfig()"
                        >New Config</rr-btn
                    >
                </div>
            </div>
        </div>
        <div class="row gap-16 singlestep">
            <div
                class="col justify-start gap-4 align-center align-self-stretch"
            >
                <div class="dot"></div>
                <!-- <div class="line grow-1"></div> -->
            </div>
            <div class="col stepoverviewcontent">
                <div class="row space-between w100">
                    <h4 class="stepheadline">Stream Results</h4>
                    <rr-btn
                        type="link"
                        size="Small"
                        iconStart="add"
                        (click)="addStreamResult()"
                        >New Result</rr-btn
                    >
                </div>
                <div class="currentresultlist w100">
                    @for (result of stream?.streamResults; track result) {
                        <div class="row space-between align-center w100">
                            <div class="col">
                                <span class="strong">{{ result.title }}</span>
                                <span class="tiny">{{
                                    result.type | getStreamClosingTypeNameById
                                }}</span>
                            </div>
                            <div class="row gap-8">
                                <rr-icon
                                    name="trash"
                                    class="w16 pointer"
                                    (click)="deleteStreamResult(result)"
                                ></rr-icon>
                                <rr-icon
                                    name="edit"
                                    class="w16 pointer"
                                    (click)="editStreamResult(result)"
                                ></rr-icon>
                            </div>
                        </div>
                    }
                </div>
                <div class="stepcontent row gap-8 align-center"></div>
            </div>
        </div>
        <rr-divider></rr-divider>
        <div class="row justify-end w100">
            <div class="row gap-8 align-center">
                <rr-btn size="Medium" type="Secondary" (click)="cancelStream()"
                    >Cancel</rr-btn
                >
                <rr-btn
                    size="Medium"
                    type="Primary"
                    [disabled]="
                        stream?.steps?.length === 0 ||
                        !stream?.streamResults ||
                        stream?.streamResults?.length === 0
                    "
                    (click)="
                        stream?.steps?.length === 0 ||
                        !stream?.streamResults ||
                        stream?.streamResults?.length === 0
                            ? null
                            : saveStream()
                    "
                    >Save Stream</rr-btn
                >
            </div>
        </div>
    </div>
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
